var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "detailed-list" }, [
    _c(
      "tr",
      { staticClass: "tr-td-control" },
      [
        _c("c-viewHeaderParam", {
          ref: "v_basic",
          attrs: {
            r_messages: _vm.r_messages,
            r_settings: _vm.r_settings,
            r_class_code: _vm.r_class_code,
            r_class_name: _vm.r_info.company_name,
            r_code: _vm.r_code,
            r_code2: _vm.r_code2,
            r_info: _vm.m_info,
            r_header: _vm.m_info,
            r_code_name: _vm.r_code_name,
            r_code2_name: _vm.r_code2_name,
            r_is_new: _vm.r_is_new
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-485b6a0e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-485b6a0e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/parts/user/header/viewParam.vue
// module id = 605
// module chunks = 0 1 2